import { request } from '@/shared/api/request'

export const getDict = () => request({ url: `dict/faqType`, method: 'GET'})
